// components/CampaignForm.js
import React, { Fragment, Component } from 'react';
import { Grid, GridColumn } from '@atlaskit/page';
import { TextField, CheckBoxField, DateTimePickerField, SelectField, FormSection, TextAreaField } from '../../../components/FormFields';
import i18n from 'i18next';
import styled from 'styled-components';
import ModeSwitcher from './ModeSwitcher'; // Импортируем новый переключатель
import { TableField } from '../../../components/FormFields';
import { Button } from '@atlaskit/button/dist/cjs/components/Button';
import CarsForm from './CarsForm';
import FieldError from '../../../components/FieldError';
import dateformat from 'dateformat';
import { convertUtcToLocal } from '../../../helpers/dateHelper';

export class CampaignFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'filter', // Начальное состояние — 'filter'
    };
  }

  handleModeChange = mode => {
    this.setState({ mode });
  };

  handleFileChange = e => {
    const file = e.target.files[0];
    this.props.onFileChange(file);
  };

  render() {
    const { campaign,
      file,
      onChange,
      onParseVinText,
      onCarsFilter,
      fetching,
      fetchingCars,
      getDictionaries,
      dictionaries,
      rules,
      t,
      cars,
      notFoundCarVins,
      textVins,
      errors,
      parsedVins } = this.props;
    const { mode } = this.state;

    return (
      <Fragment>
        <GridColumn medium={12}>
          <TextField
            name='name'
            label={i18n.t('fota:Name')}
            placeholder={i18n.t('fota:Enter Campaign Name')}
            required={true}
            onChange={onChange}
            isDisabled={fetching}
            value={campaign?.name}
          />
        </GridColumn>
        <GridColumn medium={1}>
          <CheckBoxField
            name='toFactory'
            label={i18n.t('fota:ToFactory')}
            placeholder={i18n.t('fota:ToFactory')}
            isChecked={campaign.toFactory}
            value={campaign.toFactory}
            onChange={onChange}
            size="large"
          />
        </GridColumn>
        <GridColumn medium={5}>
          <FieldError error={errors.firmware} />
          <SelectField
            name='firmware'
            label={i18n.t('fota:Firmware')}
            placeholder={campaign.toFactory ? i18n.t('fota:Firmware Canot Select') : i18n.t('fota:Select Firmware')}
            value={campaign?.firmware}
            isMulti={false}
            required={!campaign.toFactory}
            getData={() => getDictionaries('firmwares')}
            data={dictionaries.firmwares.data}
            fetching={dictionaries.firmwares.fetching}
            onChange={onChange}
            isDisabled={fetching || campaign.toFactory}
          />
        </GridColumn>
        <GridColumn medium={3}>
          <FieldError error={errors.dateEndLess} />
          <DateTimePickerField
            name='startDateTime'
            label={i18n.t('fota:Start Date')}
            placeholder={i18n.t('fota:Enter campaign start date')}
            required={true}
            onChange={onChange}
            timeIsEditable={true}
            isDisabled={fetching}
            value={campaign?.startDateTime}
          />
        </GridColumn>
        <GridColumn medium={3}>
          <DateTimePickerField
            name='endDateTime'
            label={i18n.t('fota:End Date')}
            placeholder={i18n.t('fota:Enter campaign end date')}
            required={true}
            onChange={onChange}
            timeIsEditable={true}
            isDisabled={fetching}
            value={campaign?.endDateTime}
          />
        </GridColumn>
        <GridColumn medium={12}>
          <ModeSwitcher mode={mode} onChange={this.handleModeChange} />
        </GridColumn>
        <GridColumn medium={12}>
          <FormSection label={i18n.t('fota:Select Cars')}>
            {mode === 'upload' ? (
              <FileInputContainer>
                <ButtonGroup>
                  <FieldError error={errors.cars} />
                  <FileInputButton htmlFor="file-upload">
                    Выбрать файл для загрузки VIN
                  </FileInputButton>
                  {file && <FileName>{file.name}</FileName>}
                </ButtonGroup>
                <HiddenFileInput
                  id="file-upload"
                  type="file"
                  capture="environment"
                  accept='.csv, .xls, .xlsx'
                  onChange={this.handleFileChange}
                  disabled={fetchingCars}
                />
              </FileInputContainer>
            ) : mode === 'text' ?
              (
                <GridColumn medium={12}>
                  <TextAreaField
                    name={'textVins'}
                    value={textVins}
                    label={'Вставьте список VIN'}
                    onChange={onChange}></TextAreaField>
                  <br></br>

                  <FieldError error={errors.cars} />
                  <Button
                    onClick={onParseVinText}
                    isDisabled={!((campaign.firmware || campaign.toFactory ) && parsedVins.length)}
                  >{t('Apply filter')}
                  </Button>
                </GridColumn>
              )
              : (
                <GridColumn medium={12}>
                  <TableField
                    name='rules'
                    label={t('Car filter')}
                    value={rules}
                    onChange={onChange}
                    fields={dictionaries.fotafields.data && [...dictionaries.fotafields.data]}
                    operators={dictionaries.operators.data && [...dictionaries.operators.data]}
                    andOr={dictionaries.andOr.data && [...dictionaries.andOr.data]}
                    getDictionaries={getDictionaries}
                    isDisabled={fetchingCars}
                  />

                  <FieldError error={errors.cars} />
                  <Button onClick={onCarsFilter}
                    appearance='submit'
                    isDisabled={!((campaign.firmware || campaign.toFactory ) && rules.length)}
                  >{t('Apply filter')}</Button>{!campaign.firmware}

                </GridColumn>
              )}
          </FormSection>
        </GridColumn>
        <GridColumn medium={12}>
          <CarsForm cars={cars} notFoundCarVins={notFoundCarVins}></CarsForm>
        </GridColumn>
      </Fragment>
    );
  }
}

const FileInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const FileInputButton = styled.label`
  background-color: #0052CC;
  color: white;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  &:hover {
    background-color: #003D99;
  }
`;

const FileName = styled.span`
  font-size: 14px;
  margin-left: 8px;
`;

export default CampaignFields;